import type { WorkbookDefinition, WorkbookSource } from '@erp/shared-types';
import { tableNames, unusedName } from './workbookNames';

/**
 * An inline table Source from cells copied out of a spreadsheet (tab-separated
 * lines, the first the header row), or undefined when nothing was pasted. It
 * is named `baseName`, or `baseName 2`, `baseName 3`… when a table has that
 * name: unique among the Sources and Worksheets a Formula or Lookup names.
 */
export function pastedTableSource(
  pasted: string,
  definition: Pick<WorkbookDefinition, 'sources' | 'sheets'>,
  baseName: string,
): WorkbookSource | undefined {
  if (!pasted.trim()) return undefined;
  const [headers, ...rows] = pasted
    .replace(/^\uFEFF/, '')
    // Only trailing line breaks: a tab there ends an Empty last cell.
    .replace(/[\r\n]+$/, '')
    // Excel for Mac copies lines ending in a lone CR.
    .split(/\r\n|\r|\n/)
    .map((line) => line.split('\t'));
  if (!headers) return undefined;
  return {
    id: crypto.randomUUID(),
    name: unusedName(tableNames(definition), baseName),
    folder: '',
    kind: 'input',
    table: { columns: headers, rows },
  };
}
